import { NativeStackHeaderProps } from '@react-navigation/native-stack';
import { Stack } from 'expo-router';
import React from 'react';

import { MqSwitch, tokens } from '@fhs/ui';

import { AppHeader } from '../../../components/app-header';
import { AppHeaderRightDesktop } from '../../../components/app-header/app-header-desktop';
import {
  AuthHeaderLeft,
  AuthHeaderMiddle,
} from '../../../components/app-header/auth-header/auth-header-mobile';

const routeNamesMap = {
  index: 'Log In or Sign Up',
  'verify/index': 'Verify With Code',
  'continuewithemail/index': 'Continue With Email',
  'signup/index': 'Create an Account',
};

function header(props: NativeStackHeaderProps) {
  return (
    <MqSwitch
      $base={() => <AppHeader right={<AppHeaderRightDesktop isAuthRoute />} />}
      $ltDesktop={() => (
        <AppHeader
          left={<AuthHeaderLeft />}
          middle={<AuthHeaderMiddle title={routeNamesMap[props.route.name]} />}
          right={null}
        />
      )}
    />
  );
}

export default function AuthLayout() {
  return (
    <Stack
      initialRouteName={'index'}
      screenOptions={{
        header,
        contentStyle: { backgroundColor: tokens.colors.$white },
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="signup" />
      <Stack.Screen name="continuewithemail" />
      <Stack.Screen name="verify" />
    </Stack>
  );
}
